module.exports = __webpack_public_path__ + "static/img/bg-userflow@t.03f08ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life-smart-phone-sales/bg-userflow@t.png
// module id = QXoc
// module chunks = 0